export interface ContextMenuItemModel {
  icon: string;
  title: string;
  action: ContextMenuItemAction;
  disabled: boolean;
}

export enum ContextMenuItemAction {
  DELETE_ITEM = 'deleteItem',
  VIEW = 'view',
  SEND_EMAIL = 'sendEmail',
  MOVE_TO_ARCHIVE = 'moveToArchive',
  ADD_TO_BOOKMARKS = 'addToBookmarks',
  EDIT = 'onEditClick',
  EXPORT_PDF = 'onPreviewExportPdfClick'
}

